const API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  ? 'http://localhost:8000/api'
  : 'https://api.hrms.raygain.softwarecloud.in/api';

// gulati
// const API_BASE_URL = 'http://192.168.1.4:3000/api';
export default API_BASE_URL;

